import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMousePointer } from '@fortawesome/free-solid-svg-icons';
import { useLanguage } from '../../../../contexts/LanguageContext';
import translations from './EmptyState.translations.json';
type SupportedLanguage = keyof typeof translations;

export const EmptyState: React.FC = () => {
  const { language } = useLanguage();
  const content = translations[language as SupportedLanguage] || translations.en;
  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="100%">
      <Paper
        elevation={0}
        sx={{
          p: 6,
          backgroundColor: '#121316',
          border: '1px solid #23262d',
          borderRadius: 3,
          textAlign: 'center',
          maxWidth: 420,
        }}
      >
        <Box sx={{ color: '#0a66c2', fontSize: 32, mb: 2 }}>
          <FontAwesomeIcon icon={faMousePointer} />
        </Box>
        <Typography variant="h6" fontWeight="bold" color="#FFFFFF" mb={1}>
          {content.title}
        </Typography>
        <Typography variant="body2" color="#8C939D">
          {content.description}
        </Typography>
      </Paper>
    </Box>
  );
};